import { getFileExtension } from "@/constants";
import React from "react";
import { FaFile, FaFilePdf, FaFileWord } from "react-icons/fa";

const ReportDocuments: React.FC<{ docs: string[] }> = ({ docs }) => {


	return (
		<div className="flex">
			{docs.map((url, index) => (
				<a
					href={url}
					target="_blank"
					rel="noreferrer"
					key={index}
					className="hover:rounded-md flex gap-2 hover:bg-blue-50 items-center"
				>
					{getFileExtension(url) == "pdf" ? (
						<FaFilePdf className="text-base text-red-700" />
					) : getFileExtension(url) == "docx" || "doc" ? (
						<FaFileWord className="text-base text-blue-700" />
					) : (
						<FaFile className="text-base text-red-700" />
					)}
				</a>
			))}
		</div>
	);
};

export default ReportDocuments;
